import { createSlice } from '@reduxjs/toolkit';

export const navDropdown = createSlice({
  name: 'dropdown',
  initialState: {
    isDropDown: true,
  },
  reducers: {
    toggleDropdown: (state) => {
      state.isDropDown = !state.isDropDown;
    },
    closeDropdown: (state) => {
      state.isDropDown = false;
    },
  },
});

export const { toggleDropdown, closeDropdown } = navDropdown.actions;

export default navDropdown.reducer;
